export enum VatSettingType {
  ACCOMMODATION = 1,
  LOCAL_TAX = 2,
}
